import styled from 'styled-components';

import { colors } from '@spa/shared/theme';

export const Wrapper = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  position: fixed;
  top: 0;
  left: 0;
  z-index: 3;
  width: 100vw;
  height: 100vh;
  background: rgba(0, 0, 0, 0.6);

  ${props => props.theme.smallBreakpoint`
    z-index: 5;
  `};
`;

export const Box = styled.div`
  position: relative;
  width: ${props => props.width || '40%'};
  height: ${props => props.height || 'auto'};
  max-width: ${props => props.maxWidth || '100%'};
  ${props => props.maxHeight && `max-height: ${props.maxHeight};`}
  border-radius: ${props => props.theme.rem(12)};
  box-shadow: 0 2px 7px 0 rgba(53, 53, 53, 0.5);
  background-color: white;
  display: flex;
  flex-direction: column;

  ${props => props.theme.mediumBreakpoint`
    border-radius: 0;
    width: 100%;
    height: 100%;
  `}

  > svg.close-icon {
    position: absolute;
    right: ${props => props.theme.space(4)};
    top: ${props => props.theme.space(4)};
    width: 36px;
    height: 36px;
    cursor: pointer;
    padding: ${props => props.theme.space(2)};
    border-radius: 50%;
    z-index: 1;
    background: transparent;

    > path {
      fill: ${colors.paleSky};
    }

    &:hover {
      background: ${props => props.theme.closeButton.background};
    }
  }
`;

export const Header = styled.div`
  position: sticky;
  display: flex;
  justify-content: space-between;
  align-items: center;
  min-height: 64px;
  width: 100%;
  padding: ${props => props.theme.space(4)};
  border-bottom: 1px solid ${props => props.theme.modal.header.border};

  > svg.close-icon {
    cursor: pointer;
    border-radius: 50%;
    z-index: 1;
    background: transparent;
    padding: ${props => props.theme.space(2)};
    width: 36px;
    height: 36px;
    margin-left: auto;

    > path {
      fill: ${colors.paleSky};
    }

    &:hover {
      background: ${props => props.theme.closeButton.background};
    }
  }

  ${props => props.theme.mediumBreakpoint`
    font-size: ${props => props.theme.rem(22)};
    font-weight: 600;
    line-height: ${props => props.theme.rem(26)};
    color: ${colors.blueDianne};
  `};
`;

export const Title = styled.span`
  font-family: IntervalNextReg, sans-serif;
  font-size: ${props => props.theme.rem(24)};
  font-weight: 600;
  color: ${props => props.theme.modal.header.title};
  margin-left: ${props => props.theme.space(3)};

  ${props => props.theme.mediumBreakpoint`
    font-size: ${props => props.theme.rem(22)};
    line-height: ${props => props.theme.rem(26)};
  `};
`;

export const TitleWrapper = styled.span`
  display: flex;
  justify-content: center;
  align-items: center;
`;

export const Content = styled.div`
  display: flex;
  flex-direction: column;
  overflow: auto;
  padding: ${props => props.theme.space(4)} ${props => props.theme.space(8)};
  color: ${props => props.theme.modal.text};
`;
